import moment from 'moment';
import 'bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

export function setupFilters(onChangeCallback) {
	setupDropdowns();
	setupFilterButtons(onChangeCallback);
	setupResetButton(onChangeCallback);
	setupDateRange(onChangeCallback);
}

export function getFilterParams() {
	let typesSelected = document.querySelectorAll(
		'.filter-list-types .selected',
	);
	let types = [];

	typesSelected.forEach(type => {
		if (type.classList.contains('selected')) {
			types.push(type.getAttribute('data-category'));
		}
	});

	const selectedMonth = document.querySelector(
		'.filter-list-months .filter-button.selected',
	);
	const month = selectedMonth?.getAttribute('data-month') || '';

	const dateRangeInput = document.getElementById('date-range-input')?.value;
	let start = '';
	let end = '';

	if (dateRangeInput && dateRangeInput.includes('–')) {
		const [rawStart, rawEnd] = dateRangeInput.split('–').map(s => s.trim());
		start = rawStart || '';
		end = rawEnd || '';
	}

	return {
		category: types,
		month: month,
		start: start,
		end: end,
	};
}

function setupDropdowns() {
	document
		.querySelectorAll('.button-dropdown-filter-list')
		.forEach(button => {
			button.addEventListener('click', e => {
				e.stopPropagation();
				closeAllDropdowns();
				button.nextElementSibling.classList.toggle('open');
			});
		});

	document.addEventListener('click', () => {
		closeAllDropdowns();
	});

	document.querySelectorAll('.button-filter-list-close').forEach(closeBtn => {
		closeBtn.addEventListener('click', e => {
			e.stopPropagation();
			closeBtn.parentElement.classList.remove('open');
		});
	});
}

function setupFilterButtons(onChangeCallback) {
	document.querySelectorAll('.filter-list .filter-button').forEach(button => {
		button.addEventListener('click', () => {
			const parentList = button.closest('.dropdown-filter-list');

			if (parentList.classList.contains('filter-list-types')) {
				// MULTI-SELECTION (typ akce)
				button.classList.toggle('selected');
			} else {
				// SINGLE-SELECTION (měsíc, atd.)
				const siblings = parentList.querySelectorAll('.filter-button');
				siblings.forEach(btn => btn.classList.remove('selected'));
				button.classList.add('selected');
				parentList.classList.remove('open');
			}
			onChangeCallback?.();
			updateResetButtonVisibility();
		});
	});
}

function setupResetButton(onChangeCallback) {
	const resetBtn = document.getElementById('reset-filters');
	if (!resetBtn) return;

	resetBtn.addEventListener('click', () => {
		document.querySelectorAll('.filter-button.selected').forEach(btn => {
			btn.classList.remove('selected');
		});
		const input = document.getElementById('date-range-input');
		const label = document.getElementById('date-range-label');

		if (input) {
			input.value = '';
		}
		if (label) {
			label.textContent = label.dataset.text;
		}

		updateResetButtonVisibility();
		onChangeCallback?.();
	});
}

function setupDateRange(onChangeCallback) {
	const input = document.getElementById('date-range-input');
	const label = document.getElementById('date-range-label');

	if (!input || !label) return;

	let today = moment();

	$(input).daterangepicker(
		{
			autoUpdateInput: false,
			autoApply: true,
			showDropdowns: false,
			opens: 'right',
			drops: 'down',
			showCustomRangeLabel: false,
			minDate: today,
			locale: window.datePickerLocale,
		},
		function (start, end) {
			const dateRangeInput = document.getElementById('date-range-input');

			console.log(dateRangeInput);
			if (dateRangeInput) {
				dateRangeInput.value =
					start.format('YYYY-MM-DD') +
					' – ' +
					end.format('YYYY-MM-DD');
			}

			label.textContent =
				start.format('D. M. YYYY') + ' – ' + end.format('D. M. YYYY');

			document
				.querySelector('.filter-list-months .filter-button.selected')
				?.classList.remove('selected');

			updateResetButtonVisibility?.();
			onChangeCallback?.();
		},
	);

	// Když klikneš na tlačítko „Jiný termín“, aktivuj picker
	document.querySelector('.button-range')?.addEventListener('click', () => {
		$(input).trigger('click');
	});
}

function closeAllDropdowns() {
	document.querySelectorAll('.dropdown-filter-list').forEach(list => {
		list.classList.remove('open');
	});
}

function hasActiveFilters() {
	const hasSelectedTypes =
		document.querySelectorAll('.filter-list-types .filter-button.selected')
			.length > 0;
	const hasMonth =
		document.querySelector(
			'.filter-list-months .filter-button.selected',
		) !== null;
	const hasDateRange =
		document.getElementById('date-range-input')?.value !== '';

	return hasSelectedTypes || hasMonth || hasDateRange;
}

function updateResetButtonVisibility() {
	const resetBtn = document.getElementById('reset-filters');
	if (!resetBtn) return;

	resetBtn.classList.toggle('filter-active');
}
